/** DataBest — 4-axis radar chart for the dashboard. */
import React from "react";
import {
    Radar, RadarChart as RC, PolarGrid, PolarAngleAxis, PolarRadiusAxis,
    ResponsiveContainer, Tooltip,
} from "recharts";
import RefreshingOverlay from "./RefreshingOverlay";

const DashboardRadar = ({ radar, loading = false }) => {
    const axes = radar?.axes || [];
    const chartData = axes.map((a) => ({
        subject: a.label,
        value: a.value ?? 0,
        raw_pct: a.raw_pct,
    }));

    const isEmpty = !axes.length || axes.every((a) => a.value == null);

    if (isEmpty && !loading) {
        return (
            <div
                className="flex h-[300px] flex-col items-center justify-center rounded-2xl border border-slate-200 bg-white p-6 text-center"
                data-testid="radar-empty"
            >
                <p className="font-semibold text-slate-700">No data yet</p>
                <p className="mt-1 text-xs text-slate-500">
                    Score some tasks to see the radar
                </p>
            </div>
        );
    }

    return (
        <div
            className="relative rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
            data-testid="dashboard-radar"
        >
            <div className="mb-3 flex items-center justify-between">
                <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-brand-blue-950">
                    4-Axis average
                </h3>
                <span className="text-[11px] text-slate-500">
                    n = {radar?.sample_size ?? "…"}
                </span>
            </div>
            <div className={`h-[280px] transition-opacity sm:h-[340px] ${loading ? "opacity-40" : ""}`}>
                <ResponsiveContainer width="100%" height="100%">
                    <RC data={isEmpty ? [] : chartData} outerRadius="72%">
                        <PolarGrid stroke="#e2e8f0" />
                        <PolarAngleAxis
                            dataKey="subject"
                            tick={{ fill: "#334155", fontSize: 12, fontWeight: 600 }}
                        />
                        <PolarRadiusAxis
                            angle={90}
                            domain={[0, 100]}
                            tick={{ fill: "#94a3b8", fontSize: 10 }}
                        />
                        <Radar
                            name="Score"
                            dataKey="value"
                            stroke="#1e40af"
                            fill="#3b82f6"
                            fillOpacity={0.35}
                            strokeWidth={2}
                        />
                        <Tooltip
                            formatter={(v, name, p) => {
                                if (p?.payload?.subject === "Response" && p.payload.raw_pct != null) {
                                    return [`${p.payload.raw_pct}%`, "Yes"];
                                }
                                return [v?.toFixed?.(2) ?? v, "Avg"];
                            }}
                        />
                    </RC>
                </ResponsiveContainer>
            </div>
            <RefreshingOverlay visible={loading} />
        </div>
    );
};

export default DashboardRadar;
